
export const richTextActions = {
    Bold: 'bold',
    Italics: 'italics',
    Underline: 'underline',
    Highlight: 'highlight',
    Divider: 'divider',
    Undo: 'undo',
    Redo: 'redo',
    Alignment: 'alignment',
    Heading: 'heading',
    Bullet: 'bullet',
    NumberList: 'numberList'
}


export const editorTheme = {
    text: {
        bold: 'editor-text-bold',
        italic: 'editor-text-italic',
        strikethrough: 'editor-text-strikethrough',
        underline: 'editor-text-underline',
        underlineStrikethrough: 'editor-text-underlineStrikethrough',
        highlight_gray: 'highlight_gray',
        highlight_blue: 'highlight_blue',
        highlight_green: 'highlight_green',
        highlight_yellow: 'highlight_yellow',
        highlight_orange: 'highlight_orange',
        highlight_pink: 'highlight_pink',
        highlight_purple: 'highlight_purple',
        highlight_none: 'highlight_none',
    },
    heading: {
        h1: 'editor-heading-h1',
        h2: 'editor-heading-h2',
        h3: 'editor-heading-h3',
    },
    table: 'editor-table'
}

export const LOW_PRIORITY = 1;
